import { TheEyeQuotes } from "./TheEye";

export const quotes = {
    theEye: TheEyeQuotes,
}